import './_rollupPluginBabelHelpers-addb23d1.js';
// export { S as default } from './scroll-slider-acd3343c.js';

async function loadScrollSlider() {
  const version = Date.now();  // Use current timestamp to force cache-busting
  const module = await import(`./scroll-slider-acd3343c.js?v=${version}`);
  return module.S;  // Return the default export
}

export default loadScrollSlider;
